import { styled } from "@mui/material/styles";
import { Button } from "../../Button/Button";

export const SuccessContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1400,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.space._600,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const ImageContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    width: "12.5rem",
    height: "8.5rem",
    position: "relative"
}));

export const BoldWhiteSpan = styled("span")(({ theme }) => ({
    color: theme.colors["neutral.50"],
    fontWeight: theme.fontWeights.bold
}));

export const CustomSubmitButton = styled(Button)(({ theme }) => ({
    display: "flex",
    padding: "1rem 1.5rem",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    alignSelf: "stretch"
}));

export const CTAForthContainer = styled("div")(({ theme }) => ({
    display: "flex",
    paddingTop: theme.space._200,
    justifyContent: "center",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "center",
    width: theme.space._1300,
    flexDirection: "column",
    
    "@media (max-width: 600px)": {
        width: "100%"
    }
  }));